<template>
    <b-modal
        ref="legal-role-modal"
        cancel-variant="outline-secondary"
        size="lg"
        :cancel-title="$t('Component(Button):cancel')"
        centered
        :title="title"
        @ok="$emit('save')"
        @hidden="hidden"
    >
        <ManageLegalRole
            :legal-role="legalRole"
            @input="change"
        />
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import ManageLegalRole from "@/views/administration/legislation/components/ManageLegalRole.vue";

export default {
    components: {
        BModal,
        ManageLegalRole
    },
    props: {
        legalRole: {
            type: Object,
            default() {
                return {
                    translations: {}
                }
            }
        },
        title: {
            default() {
                return this.$t('Component(ManageLegalRoleModal):title')
            }
        },
        hideHierarchyColumn: {
            default: false
        }
    },
    methods: {
        show() {
            this.$refs['legal-role-modal'].show();
        },
        hidden() {
            this.$emit('modalClosed');
        },
        change(data) {
            this.$emit('input', data)
        }
    }
}
</script>

<style scoped>

</style>
